import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainCertifiedStateGuidePage.module.scss'

import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import useModal from '@Hooks/myhouse/useModal'
import MyhouseMainCertifiedStateGuide from '@Components/myhouse/main/MyhouseMainCertifiedStateGuide'
import { MYHOUSE_AUTH_METHOD, OWNER_AUTH_WAIT, RESIDENT_AUTH_WAIT } from '@Root/contants/myhouseStateGuide'
import { AUTH_STATUS, TRADE } from '@Root/contants'
import { HouseDetail } from '@Root/slices/myhouse/mainSlice'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { MYHOUSE_AUTHENTICATION_CATEGORY_TYPE } from '@Root/contants/myhouseRegister'
import { NCLICK } from '@Root/contants/lcs'
import { handleNclick } from '@Helpers/nclick'
import useMain from '@Hooks/myhouse/main/useMain'
import { MY_HOUSE_AUTH_METHOD } from '@Root/contants/myhouse'

const cx = className.bind(style)

type Props = {
  houseDetail: HouseDetail
  tradeTypeCode?: any
  realestateTypeCode?: any
  authMethod?: any
}

const MyhouseMainCertifiedStateGuidePage: React.FC<Props> = ({ houseDetail, tradeTypeCode, realestateTypeCode, authMethod }: Props) => {
  const { open } = useModal()
  const { refreshMasonryGrid } = useMain()
  const [isOpen, setIsOpen] = useState(true)
  const [isRjtFirstVisit, setIsRjtFirstVisit] = useState(false)
  const [isFailFirstVisit, setIsFailFirstVisit] = useState(false)

  const [myHouseAuthPossible, setMyHouseAuthPossible] = useState(false)

  const failGuideTooltipKey = houseDetail?.houseNo + '_failGuide'
  const isfFirstVisitFailGuideKey = houseDetail?.houseNo + '_failFirstVisit'

  const isInstallmentSaleTicket = realestateTypeCode === 'B01' || realestateTypeCode === 'B02' || realestateTypeCode === 'B03'
  const isStoreOrBuilding = realestateTypeCode === 'D02' || realestateTypeCode === 'D03'

  const handleStateGuideClose = (e: React.MouseEvent<HTMLButtonElement>, houseNo: number, state: string) => {
    e.preventDefault()
    setIsOpen(false)
    localStorage.setItem(failGuideTooltipKey, 'close')
    refreshMasonryGrid()
  }

  const handleMyhouseAuthClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    houseDetail?.myhouseAuthStateGuide?.routeNclick && handleNclick(houseDetail?.myhouseAuthStateGuide?.routeNclick, e)

    if (isFailFirstVisit) {
      if (localStorage.getItem(isfFirstVisitFailGuideKey) === MYHOUSE_AUTH_METHOD.OWNER_FAIL) {
        open(MODAL_TYPE.AUTH_RETRY_RESIDENT, { myhouseNo: houseDetail.houseNo })
      } else if (localStorage.getItem(isfFirstVisitFailGuideKey) === MYHOUSE_AUTH_METHOD.RESIDENT_FAIL) {
        if (tradeTypeCode === TRADE.DEAL) {
          open(MODAL_TYPE.AUTH_RETRY_OWNER, { myhouseNo: houseDetail.houseNo })
        }
      }
    } else if (tradeTypeCode === TRADE.DEAL && houseDetail?.ownerAuthCnt === 2 && houseDetail?.residentAuthCnt !== 2) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/${houseDetail.houseNo}/${MYHOUSE_AUTHENTICATION_CATEGORY_TYPE.RESIDENT}`
    } else {
      window.location.href = `${process.env.REACT_APP_LAND_WEB_URL}/myhouse/auth/${houseDetail.houseNo}`
    }
  }

  useEffect(() => {
    const failGuideKey = localStorage.getItem(isfFirstVisitFailGuideKey) || ''
    if (houseDetail?.ownerAuthStatus || houseDetail?.residentAuthStatus) {
      if (
        [AUTH_STATUS.APPLY1, AUTH_STATUS.APPLY2].includes(houseDetail?.ownerAuthStatus as AUTH_STATUS) ||
        [AUTH_STATUS.APPLY1, AUTH_STATUS.APPLY2].includes(houseDetail?.residentAuthStatus as AUTH_STATUS)
      ) {
        localStorage.removeItem(isfFirstVisitFailGuideKey)
        setIsRjtFirstVisit(false)
        setIsFailFirstVisit(false)
      } else if (authMethod === MY_HOUSE_AUTH_METHOD.CERTIFICATE_OF_REALESTATE_REGISTER && houseDetail?.ownerAuthStatus === AUTH_STATUS.REJECT) {
        if (failGuideKey !== MYHOUSE_AUTH_METHOD.OWNER_REJECT) {
          //집주인인증 1차시도 실패이면서 최초방문인 경우
          setIsRjtFirstVisit(true)
          localStorage.setItem(isfFirstVisitFailGuideKey, MYHOUSE_AUTH_METHOD.OWNER_REJECT)
        } else {
          //집주인인증 1차시도 실패이면서 2번째 방문부터
          setIsRjtFirstVisit(false)
        }
      } else if (authMethod !== MY_HOUSE_AUTH_METHOD.CERTIFICATE_OF_REALESTATE_REGISTER && houseDetail?.residentAuthStatus === AUTH_STATUS.REJECT) {
        if (failGuideKey !== MYHOUSE_AUTH_METHOD.RESIDENT_REJECT) {
          //입주민인증 1차시도 실패이면서 최초방문인 경우
          setIsRjtFirstVisit(true)
          localStorage.setItem(isfFirstVisitFailGuideKey, MYHOUSE_AUTH_METHOD.RESIDENT_REJECT)
        } else {
          //입주민인증 1차시도 실패이면서 2번째 방문부터
          setIsRjtFirstVisit(false)
        }
      } else if (authMethod === MY_HOUSE_AUTH_METHOD.CERTIFICATE_OF_REALESTATE_REGISTER && houseDetail?.ownerAuthStatus === AUTH_STATUS.FAIL) {
        if (failGuideKey !== MYHOUSE_AUTH_METHOD.OWNER_FAIL) {
          //집주인인증 2차시도 실패이면서 최초방문인 경우
          setIsFailFirstVisit(true)
          localStorage.setItem(isfFirstVisitFailGuideKey, MYHOUSE_AUTH_METHOD.OWNER_FAIL)
        } else {
          //집주인인증 2차시도 실패이면서 2번째 방문부터
          setIsFailFirstVisit(false)
        }
      } else if (authMethod !== MY_HOUSE_AUTH_METHOD.CERTIFICATE_OF_REALESTATE_REGISTER && houseDetail?.residentAuthStatus === AUTH_STATUS.FAIL) {
        if (failGuideKey !== MYHOUSE_AUTH_METHOD.RESIDENT_FAIL) {
          //입주민인증 2차시도 실패이면서 최초방문인 경우
          setIsFailFirstVisit(true)
          localStorage.setItem(isfFirstVisitFailGuideKey, MYHOUSE_AUTH_METHOD.RESIDENT_FAIL)
        } else {
          //입주민인증 2차시도 실패이면서 2번째 방문부터
          setIsFailFirstVisit(false)
        }
      } else {
        setIsRjtFirstVisit(false)
        setIsFailFirstVisit(false)
      }
    }

    if (!isOpen && localStorage.getItem(failGuideTooltipKey)) {
      setIsOpen(true)
    }

    setMyHouseAuthPossible(
      !(
        (tradeTypeCode === TRADE.DEAL && houseDetail?.ownerAuthCnt === 2 && houseDetail?.residentAuthCnt === 2) ||
        (tradeTypeCode !== TRADE.DEAL && houseDetail?.residentAuthCnt === 2)
      ),
    )
  }, [houseDetail])

  if (!houseDetail || !houseDetail?.myhouseAuthStateGuide || !houseDetail?.myhouseAuthStateGuide?.state) {
    return <></>
  }

  if (houseDetail.tradeExpiredGuide) {
    return (
      <div className={cx('article')}>
        <MyhouseMainCertifiedStateGuide {...houseDetail.tradeExpiredGuide} houseNo={houseDetail.houseNo} />
      </div>
    )
  }
  // INIT(인증전) || ING(인증진행중) || (쿠키==RJT(1차실패)이면서 최초방문이고 가이드 state=FAIL) || (쿠키==FAIL(2차실패)이면서 최초방문이고 가이드 state=FAIL)
  if (houseDetail?.myhouseAuthStateGuide?.state === 'INIT' || houseDetail?.myhouseAuthStateGuide?.state === 'ING') {
    return (
      <div className={cx('article')}>
        <MyhouseMainCertifiedStateGuide
          {...houseDetail.myhouseAuthStateGuide}
          houseNo={houseDetail.houseNo}
          authApplyDate={houseDetail.authApplyDate}
          myHouseAuthPossible={myHouseAuthPossible}
          handleStateGuideClose={handleStateGuideClose}
          handleMyhouseAuthClick={handleMyhouseAuthClick}
        />
      </div>
    )
  }

  if (houseDetail?.myhouseAuthStateGuide?.state === 'FAIL') {
    if (
      ((localStorage.getItem(isfFirstVisitFailGuideKey) === MYHOUSE_AUTH_METHOD.OWNER_REJECT ||
        localStorage.getItem(isfFirstVisitFailGuideKey) === MYHOUSE_AUTH_METHOD.RESIDENT_REJECT) &&
        isRjtFirstVisit &&
        isOpen) ||
      ((localStorage.getItem(isfFirstVisitFailGuideKey) === MYHOUSE_AUTH_METHOD.OWNER_FAIL ||
        localStorage.getItem(isfFirstVisitFailGuideKey) === MYHOUSE_AUTH_METHOD.RESIDENT_FAIL) &&
        isFailFirstVisit &&
        isOpen)
    ) {
      return (
        <div className={cx('article')}>
          <MyhouseMainCertifiedStateGuide
            {...houseDetail.myhouseAuthStateGuide}
            houseNo={houseDetail.houseNo}
            authApplyDate={houseDetail.authApplyDate}
            contents={houseDetail.authResultComment}
            myHouseAuthPossible={myHouseAuthPossible}
            handleStateGuideClose={handleStateGuideClose}
            handleMyhouseAuthClick={handleMyhouseAuthClick}
          />
        </div>
      )
    }

    if (!isRjtFirstVisit && !isFailFirstVisit) {
      // 인증실패 후 다음 접근부턴 기존 첫 가이드 제공
      // 주거형태가 '매매'인 경우, 상가/건물인 경우에는 우리집 인증가이드 -> 총 4번 인증기회 중 1번이라도 남아 있으면 다시 가이드 제공
      // 주거형태가 '월세,전세'인 경우, 분양권인 경우 입주민 인증가이드 -> 입주민 인증기회가 남아있어야 다시 가이드 제공
      if (!isInstallmentSaleTicket && tradeTypeCode === TRADE.DEAL && houseDetail?.ownerAuthCnt !== 2 && houseDetail?.residentAuthStatus !== AUTH_STATUS.COMPLETION) {
        return (
          <div className={cx('article')}>
            <MyhouseMainCertifiedStateGuide
              {...OWNER_AUTH_WAIT}
              houseNo={houseDetail.houseNo}
              myHouseAuthPossible={myHouseAuthPossible}
              handleMyhouseAuthClick={handleMyhouseAuthClick}
            />
          </div>
        )
      }

      if (
        houseDetail?.residentAuthStatus !== AUTH_STATUS.COMPLETION &&
        (((tradeTypeCode !== TRADE.DEAL || isInstallmentSaleTicket) && houseDetail?.residentAuthCnt !== 2) ||
          (tradeTypeCode === TRADE.DEAL && houseDetail?.ownerAuthCnt === 2 && houseDetail?.residentAuthCnt !== 2))
      ) {
        if (isStoreOrBuilding) {
          return (
            <div className={cx('article')}>
              <MyhouseMainCertifiedStateGuide
                {...OWNER_AUTH_WAIT}
                houseNo={houseDetail.houseNo}
                myHouseAuthPossible={myHouseAuthPossible}
                handleMyhouseAuthClick={handleMyhouseAuthClick}
              />
            </div>
          )
        } else {
          return (
            <div className={cx('article')}>
              <MyhouseMainCertifiedStateGuide
                {...RESIDENT_AUTH_WAIT}
                houseNo={houseDetail.houseNo}
                myHouseAuthPossible={myHouseAuthPossible}
                handleMyhouseAuthClick={handleMyhouseAuthClick}
              />
            </div>
          )
        }
      }
    }
  }

  return <></>
}

export default MyhouseMainCertifiedStateGuidePage
